export default [
  {
    id: 'accordion',
    text: 'accordion'
  }, {
    id: 'background_vocals',
    text: 'background_vocals'
  }, {
    id: 'banjo',
    text: 'banjo'
  }, {
    id: 'bass_guitar',
    text: 'bass_guitar'
  }, {
    id: 'bassoon',
    text: 'bassoon'
  }, {
    id: 'bells',
    text: 'bells'
  }, {
    id: 'cello',
    text: 'cello'
  }, {
    id: 'clarinet',
    text: 'clarinet'
  }, {
    id: 'drums',
    text: 'drums'
  }, {
    id: 'fiddle',
    text: 'fiddle'
  }, {
    id: 'flute',
    text: 'flute'
  }, {
    id: 'guitar',
    text: 'guitar'
  }, {
    id: 'harmonica',
    text: 'harmonica'
  }, {
    id: 'harp',
    text: 'harp'
  }, {
    id: 'horns',
    text: 'horns'
  }, {
    id: 'keyboards',
    text: 'keyboards'
  }, {
    id: 'lute',
    text: 'lute'
  }, {
    id: 'oboe',
    text: 'oboe'
  }, {
    id: 'organ',
    text: 'organ'
  }, {
    id: 'percussion',
    text: 'percussion'
  }, {
    id: 'piano',
    text: 'piano'
  }, {
    id: 'recorder',
    text: 'recorder'
  }, {
    id: 'saxophone',
    text: 'saxophone'
  }, {
    id: 'synthesizer',
    text: 'synthesizer'
  }, {
    id: 'tambourine',
    text: 'tambourine'
  }, {
    id: 'trombone',
    text: 'trombone'
  }, {
    id: 'trumpet',
    text: 'trumpet'
  }, {
    id: 'viola',
    text: 'viola'
  }, {
    id: 'viola_da_gamba',
    text: 'viola_da_gamba'
  }, {
    id: 'violin',
    text: 'violin'
  }, {
    id: 'vocals',
    text: 'vocals'
  }, {
    id: 'whistle',
    text: 'whistle'
  }, {
    id: 'xylophone',
    text: 'xylophone'
  }
]



// WEBPACK FOOTER //
// ./src/data/performers-instruments.js